import React from 'react'

import { useTranslation } from 'react-i18next';
import ImgExpo from './pexels-cowomen-2041396.jpg'
import ImgExpo2 from './pexels-hermaion-205414.jpg'
import ImgExpo3 from './pexels-sevenstorm-juhaszimrus-1604991.jpg'

const OffreTarifHome = () => {
    // const [show, SetShow] = useState(false)

    const { t } = useTranslation();

    return (
        <div>


            <h1 className="text-center">{t('OffreTarifHome.Title')}</h1>
            <div className="bg-bordeaux mx-auto" style={{height: "6px", width: "100px"}}></div>

            <div className="container-fluid pt-3">
                <div className="row justify-content-md-center text-center ">

                    <div className="col-md-3 col-11 border m-4 shadow-lg rounded-lg position-relative" style={{paddingRight: "0px",paddingLeft: "0px"}} >
                        
                        <h2>{t('OffreTarif.Gauche.title')}</h2>
 
                        <div className="bg-dark rounded-circle mx-auto" style={{backgroundImage: `url(${ImgExpo})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", height: "200px", width: "200px"}}></div>

                        <p className="text-left mx-4 mt-3 h6">
                            {t('OffreTarifHome.Gauche.argu1')}
                        </p>

                        <p className="text-left mx-4 mt-3 h6">
                            {t('OffreTarifHome.Gauche.argu2')}
                        </p>
                           
                        <div className="bg-bordeaux fixed-bottom position-absolute" style={{height: "3px", width: "100%"}}></div>
                       
                    </div>



                    <div className="col-md-3 col-11 border m-4 shadow-lg position-relative " style={{paddingRight: "0px",paddingLeft: "0px"}} >
                    
                        <h2>{t('OffreTarifHome.Milieu.title')}</h2>
                        
                        <div className="bg-dark rounded-circle mx-auto" style={{backgroundImage: `url(${ImgExpo2})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", height: "200px", width: "200px"}}></div>

                        <p className="text-left ml-4 h6">   
                        {t('OffreTarifHome.Milieu.argu1')}  
                        </p>

                        <p className="text-left ml-4 h6">
                        {t('OffreTarifHome.Milieu.argu2')}
                        </p>

                        <p className="text-left ml-4 h6">
                        {t('OffreTarifHome.Milieu.argu3')}
                        </p>

                        <p className="text-left ml-4 h6">
                        {t('OffreTarifHome.Milieu.argu4')}
                        </p>    

                        <div className="bg-bordeaux fixed-bottom position-absolute" style={{height: "3px", width: "100%"}}></div>

                    </div>

                    <div className="col-md-3 col-11 border m-4 shadow-lg position-relative" >
                        

                        <div>
                            <h2>{t('OffreTarif.Droite.title')}</h2>

                            <div className="bg-dark rounded-circle mx-auto" style={{backgroundImage: `url(${ImgExpo3})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", height: "200px", width: "200px"}}></div>

                            <div className="mt-5">
                                <p className="text-left ml-4 h6">
                                {t('OffreTarifHome.Droite.argu1')}
                                </p>
                            </div>
                        </div>
                       
                        <div className="bg-bordeaux fixed-bottom position-absolute" style={{height: "3px", width: "100%"}}></div>

                    </div>

                </div>

                {/* <div>
                   {show &&  <Tarifs /> } 
                </div> */}

            </div>
            
        </div>
    )
}

export default OffreTarifHome


// style={{cursor: "pointer",paddingRight: "0px",paddingLeft: "0px"}} onClick={() => SetShow(!show) }